import request from "@/utils/request"
/**
 * 获取广告图
 * @returns Promise
 */

//获取题库列表
export const findTestsItem = ({ maID, chID, coID, page, size }) => {
  return request('/tests/testslist', 'get', { maID, chID, coID, page, size })
}

//获取题库详情

export const findTestsDetail = (id) => {
  return request('/tests/testsdetail', 'get', { id })
}

export const findTestsCheckOut = (id) => {
  return request('/tests/testscheck', 'get', { id })
}


/* 
//获取视频推荐
export const findVideoRecommand = (clID) => {
  return request('/video/recommend', 'get', { clID })
}

//获取video视频
export const findLesson = ({ maID, chID, coID, clID, page, size }) => {
  return request('/video/lesson', 'get', { maID, chID, coID, clID, page, size })
}

export const findVideoPlay = (id) => {
  return request('/video/play', 'get', { id })
} */